import React from "react";
import { connect } from "react-redux";
import { Input, Select } from "../Input";
import { Button } from "../Button";
import language from "../../language";
import toastMessage from "../../utils/toastMessage";
import { addDiagnosisOption } from "../../utils/queries/diagnosisOptions";
import { fetchProductTypes } from "../../utils/queries/productsType";

class NewDiagnosisOption extends React.Component {
  state = {
    label: "",
    value: "",
    productTypes: [],
    productTypeOptions: [],
    error: {},
    isSubmitting: false,
  };

  componentDidMount = async () => {
    await this.getProductTypes();

    if (this.props._id) {
      this.setState({
        label: this.props.label || "",
        value: this.props.value || "",
        productTypes: (this.props.productTypes || []).map((el) => ({
          label: el,
          value: el,
        })),
      });
    }
  };

  getProductTypes = async () => {
    const data = await fetchProductTypes(this.props.defaultLanguage, {
      inputType: "dropdown",
      page: 1,
      limit: 500,
    });

    const productTypeOptions = (data || [])
      .map((el) => ({
        label: el.code,
        value: el.code,
      }))
      .filter(
        (el, index, arr) =>
          arr.findIndex((item) => item.value === el.value) === index
      );

    this.setState({ productTypeOptions });
  };

  onChangeText = (field, e) => {
    const inputValue = e?.target ? e.target.value : e;
    const { error } = this.state;
    delete error[field];

    this.setState({
      [field]: inputValue,
      error,
    });
  };

  validateForm = () => {
    const { label, value } = this.state;
    const error = {};

    if (!label || !label.trim()) {
      error.label = language[this.props.defaultLanguage].label_required;
    }
    if (!value || !value.trim()) {
      error.value = language[this.props.defaultLanguage].value_required;
    }

    this.setState({ error });
    return Object.keys(error).length === 0;
  };

  onSubmit = async () => {
    if (!this.validateForm()) return;

    try {
      this.setState({ isSubmitting: true });

      const payload = {
        label: this.state.label.trim(),
        value: this.state.value.trim(),
        productTypes: (this.state.productTypes || []).map((el) => el.value),
      };

      if (this.props._id) {
        payload.id = this.props._id;
      }

      await addDiagnosisOption(payload);

      toastMessage(
        "success",
        language[this.props.defaultLanguage][
          this.props._id ? "update_data_success" : "add_data_success"
        ]
      );

      this.setState({ isSubmitting: false });
      this.props.getData(true);
      this.props.handleCloseModal();
    } catch (error) {
      this.setState({ isSubmitting: false });
      toastMessage("error", error);
    }
  };

  render() {
    return (
      <div className="card-body">
        <div className="row">
          <div className="col-md-12">
            <Input
              label={language[this.props.defaultLanguage].label}
              value={this.state.label}
              onChange={(e) => this.onChangeText("label", e)}
              error={this.state.error.label}
              required
            />
          </div>
          <div className="col-md-12">
            <Input
              label={language[this.props.defaultLanguage].value}
              value={this.state.value}
              onChange={(e) => this.onChangeText("value", e)}
              error={this.state.error.value}
              required
            />
          </div>
          <div className="col-md-12">
            <Select
              options={this.state.productTypeOptions}
              label={language[this.props.defaultLanguage].product_type}
              value={this.state.productTypes}
              onChange={(e) => this.onChangeText("productTypes", e || [])}
              isCreatable
              isMulti
            />
          </div>
          <div className="modal-footer">
            <Button
              text={language[this.props.defaultLanguage].cancel}
              onPress={this.props.handleCloseModal}
              className="btn-default"
            />
            <Button
              text={language[this.props.defaultLanguage].save}
              onPress={this.onSubmit}
              isSubmitting={this.state.isSubmitting}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return { defaultLanguage };
};

export default connect(mapStateToProps)(NewDiagnosisOption);
